import React from "react";
import { useNavigate } from "react-router-dom";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { CheckCheck, Bell } from "lucide-react";
import { userApi } from "@/lib/api";
import { fmtDate } from "@/lib/format";
import { PageHeader, EmptyState } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

const DOT = { success: "bg-emerald-500", error: "bg-rose-500", warning: "bg-amber-500", info: "bg-sky-500" };

export default function Notifications() {
  const qc = useQueryClient();
  const nav = useNavigate();
  const { data, isLoading } = useQuery({ queryKey: ["notifications", "page"], queryFn: () => userApi.get("/notifications", { params: { limit: 100 } }).then((r) => r.data), refetchInterval: 15000 });
  const refresh = () => qc.invalidateQueries({ queryKey: ["notifications"] });
  return (
    <div>
      <PageHeader title="Notifications" subtitle="Deposit status changes, wallet credits and exchange confirmations."
        actions={<Button variant="outline" className="gap-1.5" onClick={async () => { await userApi.post("/notifications/read-all"); refresh(); }} data-testid="notifications-page-mark-all"><CheckCheck className="h-4 w-4" /> Mark all read</Button>} />
      {isLoading ? <Skeleton className="h-64" /> : data?.items?.length === 0 ? <EmptyState icon={Bell} title="No notifications yet" /> : (
        <Card className="divide-y">
          {data.items.map((n) => (
            <button key={n.id} data-testid="notifications-page-item" onClick={async () => { if (!n.read) { await userApi.post(`/notifications/${n.id}/read`); refresh(); } if (n.link) nav(n.link); }}
              className={cn("flex w-full gap-3 px-4 py-4 text-left transition-colors hover:bg-secondary sm:px-6", !n.read && "bg-sky-50/60")}>
              <span className={cn("mt-1.5 h-2 w-2 shrink-0 rounded-full", DOT[n.type] || DOT.info)} />
              <div className="min-w-0 flex-1"><p className="text-sm font-medium">{n.title}</p><p className="text-sm text-muted-foreground">{n.message}</p></div>
              <span className="whitespace-nowrap text-xs text-muted-foreground">{fmtDate(n.created_at)}</span>
            </button>
          ))}
        </Card>
      )}
    </div>
  );
}
